import { render, staticRenderFns } from "./BxOrderList.vue?vue&type=template&id=767fb423&scoped=true&"
import script from "./BxOrderList.vue?vue&type=script&lang=js&"
export * from "./BxOrderList.vue?vue&type=script&lang=js&"
import style0 from "./BxOrderList.vue?vue&type=style&index=0&id=767fb423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fb423",
  null
  
)

export default component.exports